import theme from 'src/theme';

const styles = {
  container: {
    margin: '24px 0px'
  },
  titleText: {
    fontSize: 18,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  description: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.text.primary,
    margin: '8px 0px'
  },
  domainContainer: {
    padding: '16px 0px',
  },
  domainRow: {
    padding: '0px 16px',
    display: 'flex',
  },
  domainItem: {
    padding: '8px 16px',
  },
  columnLabel: {
    color: theme.palette.text.primary,
    fontSize: 14,
    margin: '8px 0px',
    fontWeight: 500,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '0px 24px'
  },
  checkConnectionButton: {
    fontSize: 14,
    fontWeight: 500,
    height: 36,
    minWidth: 108,
    textTransform: 'none',
    backgroundColor: theme.palette.button.cancel,
    color: theme.palette.text.primary,
    paddingTop: 0,
    paddingBottom: 0,
    border: theme.palette.border.cancel,
    margin: '6px 0px 6px 0px'
  },
};

export default styles;
